import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-preferences',
	templateUrl: './preferences.component.html',
	standalone: false,
})
export class ProfilePreferencesComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
